<script lang="ts" setup>
  import { computed } from 'vue'
  import { TEST_ID } from './CountryFlag.constants'
  import AllWorldIcon from '@/shared/components/icons/AllWorldIcon.vue'
  import Eu2Icon from '@/shared/components/icons/Eu2Icon.vue'

  interface Props {
    iso: string
  }
  const props = defineProps<Props>()
  const isoLowerCase = computed(() => props.iso.toLowerCase())
  const isGlobal = computed(() => isoLowerCase.value === 'global')
  const isEu2 = computed(() => isoLowerCase.value === 'eu-2')

  const viewBox__TEMPORARY_DECISION = computed(() => {
    if (isoLowerCase.value === 'schengen') {
      return '0 0 50 30'
    } else {
      return '0 0 50 50'
    }
  })

  const imagePath = computed(() => {
    if (isoLowerCase.value) {
      return `/web-cdn/qatar/global/images/flags.svg#${isoLowerCase.value}`
    }

    return ''
  })
</script>

<template>
  <div class="flag" :data-test="TEST_ID">
    <AllWorldIcon v-if="isGlobal" />
    <Eu2Icon v-else-if="isEu2" />
    <svg v-else width="50" height="50" :viewBox="viewBox__TEMPORARY_DECISION">
      <use :xlink:href="imagePath"></use>
    </svg>
  </div>
</template>

<style lang="scss" scoped>
  .flag {
    width: 48px;
    height: 32px;
    display: inline-block;

    svg {
      width: inherit;
      height: inherit;
    }
  }
</style>
